import React from 'react';
import Debugger from './Debugger';
import HttpService from './HttpService';
import MediaManagerModel from './MediaManagerModel';
import _ from 'lodash';
import moment from 'moment';
import jwt_decode from 'jwt-decode';
import BaseAppModel from './BaseAppModel';
import SignupForm from './SignupForm';
import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';
import ResetPasswordForm2 from './ResetPasswordForm2';
import TakeExperimentForm from './TakeExperimentForm';
import ProfileForm from './ProfileForm';
import ViewExperimentsForm from './ViewExperimentsForm';
import ManageExperimentsForm from './ManageExperimentsForm';
import ResultsForm from './ResultsForm';
import BuilderForm from './BuilderForm';
import SendMessageForm from './SendMessageForm';

const API_ENDPOINT = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_ENDPOINT : process.env.REACT_APP_DEV_API_ENDPOINT
const CLIENT_ID = "25638kqt4i3h1m5mmk7nae7k41";
const SESSION_LENGTH_IN_MINUTES = 30;

const statusMap = {
	active:    {label:'Active', value:'active', color:'var(--green)'},
	inactive:  {label:'Inactive', value:'inactive', color:'var(--yellow)'},
	archived:  {label:'Archived', value:'archived', color:'var(--red)'},
};

const STATUS_OPTIONS = _.values(statusMap);

const EXPERIMENT_DEFAULTS = {
	experimentId: null,
	status: 'inactive',
	participants: 0,
	participantCap: 0,
	name: '',
	description: '',
	start: '',
	time: 0,
	incentive: 0,
	rules:[],
	definition:{}
};

export default class AppModel extends BaseAppModel{
	constructor(appComponent){
		super(appComponent);
		this.baseURL = API_ENDPOINT; // TODO, pull in from config
		this.debugger = new Debugger(this);
		this.http = new HttpService(this);
		this.showLog = true; // Shows the log in the debugger

		this.statusMap = statusMap;
		this.STATUS_OPTIONS = STATUS_OPTIONS;
		this.EXPERIMENT_DEFAULTS = EXPERIMENT_DEFAULTS;

		this.user = this.localStorage('user');

		this.summaryData = {
			participants: '',
			averageTime: '',
			quitters: '',
		};

		this.takeExperimentForm = {};
		this.signupForm = new SignupForm(this);
		this.loginForm = new LoginForm(this);
		this.resetPasswordForm = new ResetPasswordForm(this);
		this.resetPasswordForm2 = new ResetPasswordForm2(this);
		this.profileForm = new ProfileForm(this);
		this.viewExperimentsForm = new ViewExperimentsForm(this);
		this.manageExperimentsForm = new ManageExperimentsForm(this);
		this.resultsForm = new ResultsForm(this);
		this.builderForm = new BuilderForm(this);
		this.sendMessageForm = new SendMessageForm(this);
		this.takeExperimentForm = new TakeExperimentForm(this);
		this.mediaManager = new MediaManagerModel(this);

		this.refreshTokensIfUserIsActive = this.refreshTokensIfUserIsActive.bind(this);
	
		this.refreshTokensIfUserIsActive();
		setInterval(this.refreshTokensIfUserIsActive, 60000 * 5);
	}

	get authentication(){
		return this.localStorage('authentication');
	}

	set authentication(value){
		this.localStorage('authentication', value);
	}

	export(){
		console.log(JSON.stringify(this.experiment.data, null, '\t'));
	}

	async createExperiment(){
		let experiment = {...EXPERIMENT_DEFAULTS};
		experiment.name = `New Experiment - ${moment().format('lll')}`;
		
		const form = this.manageExperimentsForm;
		this.startLoadingForm(form);
		try{
			const result = await this.http.createExperiment({experiment});
			this.stopLoadingForm(form);
			this.history.push(`/edit-experiment/${result.experimentId}`);
		}catch(e){
			console.log(e);
			this.stopLoadingForm(form, e);
		}
	}

	async duplicateExperiment({experimentId}){
		const form = this.manageExperimentsForm;
		this.startLoadingForm(form);
		try{
			const result = await this.http.duplicateExperiment({experimentId});
			this.stopLoadingForm(form);
			this.history.push(`/edit-experiment/${result.experimentId}`);
		}catch(e){
			console.log(e);
			this.stopLoadingForm(form, e);
		}
	}

	async getUser(){
		const authentication = this.authentication;
		const userResult = await this.http.getUser();

		// {
		// 	"email":{"S":"jonnydmoon+1521172796323@gmail.com"},
		// 	"id":{"S":"069f8fdf-a704-474c-811f-02285d893f0f"},
		// 	"profile":{"M":{"Birthdate":{"S":"19760825"}}}
		// }

		this.validate(!!userResult.email, "There was an error logging in. Please try again.")

		this.user = {
			username: userResult.email, // This is not really the username.
			email: userResult.email,
			isResearcher: authentication.isResearcher,
		};

		this.localStorage('user', this.user);
	}

	get isTokenExpired(){
		if( this.remainingTokenTimeInMinutes < 2 ){ // See if there is less than 2 minutes remaining
			return true;
		}
		return false;
	}

	get remainingTokenTimeInMinutes(){
		let authentication = this.authentication;
		if (!authentication || !authentication.IdToken){
			return true;
		}

		let decodedToken = jwt_decode(authentication.IdToken);
		let remainingTimeInMinutes = (decodedToken.exp - (Date.now() / 1000)) / 60;
		return remainingTimeInMinutes;
	}

	get minutesSinceLastUserInteraction(){
		this.lastUserInteractionTimestamp = this.lastUserInteractionTimestamp || Date.now();
		return (Date.now() - this.lastUserInteractionTimestamp) / 1000 / 60;
	}

	logout(killSessionOnServer = true, redirectToLogoutScreen = false){
		this.closeFullScreenDialog();
		this.user = null;
		if(killSessionOnServer && !!this.localStorage('authentication')){
			this.http.logoutUser({AccessToken: this.localStorage('authentication').AccessToken}).catch( e => {} ); // This is asynchronous, but we don't care to wait for it.
		}
		this.localStorage('user', null);
		this.localStorage('authentication', null);

		if(redirectToLogoutScreen){
			window.onbeforeunload = null;
			this.history.push('/logout');
			this.forceUpdate();
		}
	}

	async deleteAccount(){
		let message = 'Your account has been deleted.';
		this.loadingDialog();
		try{
			await this.http.deleteUser();
			this.logout();
		}catch(e){
			message = e.toString ? e.toString() : e;
		}

		this.closeDialog();
		this.goToMessagePage({
			title: 'Delete Account Confirmation',
			body: (<div>{message}</div>)
		});
	}

	// If the user did anything in the last 45 minutes, then try to refresh the tokens.
	refreshTokensIfUserIsActive(){
		if(!this.authentication){ return; }
		const userIsActive = this.minutesSinceLastUserInteraction <= SESSION_LENGTH_IN_MINUTES;
		if(userIsActive){
			this.refreshTokens();
		}else{
			this.logout(true, true);
		}
	}

	refreshTokens(){

		if(this.remainingTokenTimeInMinutes > 10){
			//console.log('No need to refresh, minutes remaining:', this.remainingTokenTimeInMinutes);
			return; // If we have more than 10 minutes remaining, we don't need to worry about it.
		}
		
		let AWS = window.AWS;
		const authentication = this.authentication;

		if(!authentication){ return; }

		console.log('Refreshing tokens!');

		let decodedToken = jwt_decode(authentication.IdToken);
		const loginPrincipal = decodedToken.iss.split('https://')[1];
		const UserPoolId = decodedToken.iss.split('amazonaws.com/')[1];
		const region = UserPoolId.split('_')[0];

		var credentials = new AWS.CognitoIdentityCredentials({
			IdentityId: authentication.IdentityId,
			Logins:{
				[loginPrincipal]: authentication.IdToken
			}
		});

		AWS.config.update({region, credentials});

		// This is used to update the session stuff.
		AWS.config.credentials.refresh(err => {
			if(err){
				console.log(err);
				this.logout(false, true);
			}
			else{
				let authentication = this.authentication;
				authentication.Credentials = {...credentials.data.Credentials};
				this.authentication = authentication; // Set it back on localstorage.
			}
		});

		var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();

		var params = {
			AuthFlow: 'REFRESH_TOKEN_AUTH', /* required */
			ClientId: CLIENT_ID, /* required */
			AuthParameters: {
			  'REFRESH_TOKEN': authentication.RefreshToken,
			}
		};

		cognitoidentityserviceprovider.initiateAuth(params, (err, data) => {
			if (err){
				console.log(err, err.stack);
				this.logout(false, true);
			} // an error occurred
			else{
				let authentication = this.authentication;
				authentication.AccessToken = data.AuthenticationResult.AccessToken;
				authentication.IdToken = data.AuthenticationResult.IdToken;
				this.authentication = authentication; // Set it back on localstorage.
			}
		});
	}
}




// WEBPACK FOOTER //
// ./src/models/AppModel.js